import EventService from '../../../helpers/classes/EventService';
import { ImageService } from '../../../helpers/classes/ImageService';
import LanguageService from '../../../helpers/classes/LanguageService';
import RenderingService from '../../../helpers/classes/RenderingService';
import TemplateService from '../../../helpers/classes/TemplateService';
import { removeNullOrUndefined } from '../../../helpers/functions/object';
import DataService, { DataStoreType } from '../../classes/DataService';
import { JourneyContainer } from '../../classes/JourneyContainer';
import { JourneyEvent } from '../../enums/JourneyEvent';
import { RequiredInputImage } from '../../enums/RequiredInputImage';
import { Templates } from '../../enums/Templates';
import { TranslationKey } from '../../enums/Translation';
import { IIdScanData } from '../../interfaces/DataFormats';
import { IExtendedDocument } from '../../interfaces/Document';
import { IPerson } from '../../interfaces/Person';
import { UploadResponse } from '../../interfaces/UploadResponse';
import { ImageFormat } from '../../enums/ImageFormat';
import { IMetaData } from '../../interfaces/MetaData';
import { FlowState } from '../../enums/FlowState';
import HttpService from '../../../helpers/classes/HttpService';
import * as lottie from 'lottie-web/build/player/lottie';
import { AnimationService } from '../../../helpers/classes/AnimationService';

export class ImageProvider {
	public static render(this: JourneyContainer, base64: string, metaData: IMetaData[]) {
		return TemplateService.getElements(this._container, {
			providerContainer: '[data-jcs-element="provider__container"]',
		})
			.then(({ providerContainer }) => TemplateService.renderToContainer(providerContainer, Templates.View))
			.then((providerContainer) => TemplateService.getElements(providerContainer, {
				retry: '[data-jcs-element="view__retry"]',
				crop: '[data-jcs-element="view__begin__crop"]',
				image: '[data-jcs-element="view__preview"]',
				upload: '[data-jcs-element="view__upload"]',
				status: '[data-jcs-element="view__status"]',
				statusMessage: '[data-jcs-element="view__status__message"]',
				openPreviewInfoId: '[data-jcs-element="preview__page__open__info__id"]',
				previewInfoContainerId: '[data-jcs-element="preview__info__container__id"]',
				closePreviewInfoId: '[data-jcs-element="preview__page__close__info__id"]',
				openPreviewInfoFM: '[data-jcs-element="preview__page__open__info__fm"]',
				previewInfoContainerFM: '[data-jcs-element="preview__info__container__fm"]',
				closePreviewInfoFM: '[data-jcs-element="preview__page__close__info__fm"]',
				openPreviewInfoPOA: '[data-jcs-element="preview__page__open__info__poa"]',
				openPreviewInfoCovid: '[data-jcs-element="preview__page__open__info__covid"]',
				previewInfoContainerPOA: '[data-jcs-element="preview__info__container__poa"]',
				previewInfoContainerCovid: '[data-jcs-element="preview__info__container__covid"]',
				closePreviewInfoPOA: '[data-jcs-element="preview__page__close__info__poa"]',
				closePreviewInfoCovid: '[data-jcs-element="preview__page__close__info__covid"]',
				idDocumentContainer: '[data-jcs-element="identity__document__preview"]',
				facematchContainer: '[data-jcs-element="facematch__preview"]',
				addressContainer: '[data-jcs-element="address__preview"]',
				covidContainer: '[data-jcs-element="covid__preview"]',
				attemptCountContainer: '[data-jcs-element="attempt__count__container"]',
				attemptCounter: '[data-jcs-element="attempt__counter"]',
				loadingAnimationContainer: '[data-jcs-element="loading-animation"]',
			}))
			.then(({ image, retry, upload, crop, status, statusMessage, openPreviewInfoId, previewInfoContainerId, closePreviewInfoId, openPreviewInfoCovid, previewInfoContainerCovid, closePreviewInfoCovid, openPreviewInfoFM, previewInfoContainerFM, closePreviewInfoFM, openPreviewInfoPOA, previewInfoContainerPOA, closePreviewInfoPOA, idDocumentContainer, facematchContainer, addressContainer, covidContainer, attemptCountContainer, attemptCounter, loadingAnimationContainer }) => {
				RenderingService.hideObject(previewInfoContainerId);
				RenderingService.hideObject(previewInfoContainerFM);
				RenderingService.hideObject(previewInfoContainerPOA);
				RenderingService.hideObject(previewInfoContainerCovid);
				RenderingService.hideObject(closePreviewInfoId);
				RenderingService.hideObject(closePreviewInfoFM);
				RenderingService.hideObject(closePreviewInfoPOA);
				RenderingService.hideObject(previewInfoContainerCovid);
				RenderingService.hideObject(closePreviewInfoCovid);
				RenderingService.hideObject(idDocumentContainer);
				RenderingService.hideObject(facematchContainer);
				RenderingService.hideObject(addressContainer);
				RenderingService.hideObject(covidContainer);
				RenderingService.hideObject(loadingAnimationContainer);
				RenderingService.setEnabled(upload as HTMLInputElement, true);
				RenderingService.setEnabled(crop as HTMLInputElement, true);
				RenderingService.setEnabled(retry as HTMLInputElement, true);
				ImageProvider.loadingAnimation = AnimationService.CreateAnimation(loadingAnimationContainer as HTMLDivElement, this.assetsFolder + '/animations/loading.json', true, true, {});
				TemplateService.getElements(this._container, {
					uploadToggleButton: '[data-jcs-element="gateway__upload__toggle"]',
				}).then(({ uploadToggleButton }) => {
					RenderingService.hideObject(uploadToggleButton);
				});

				if (this._journey) {
					switch (this._journey.action) {
						case FlowState.SELFIE:
						case FlowState.PASSIVE_LIVENESS:
							RenderingService.showObject(facematchContainer);
							break;
						case FlowState.IDENTITY_BACK:
						case FlowState.IDENTITY_FRONT:
							RenderingService.showObject(idDocumentContainer);
							break;
						case FlowState.ADDRESS:
							RenderingService.showObject(addressContainer);
							break;
						case FlowState.COVIDPASS:
							RenderingService.showObject(covidContainer);
							break;
					}

					switch (this._journey.actionAttempt) {
						case 2:
							RenderingService.setText(attemptCounter, '2');
							break;
						case 3:
							RenderingService.setText(attemptCounter, '1');
							break;
						default:
							RenderingService.hideObject(attemptCountContainer);
							break;
					}
				}

				if (crop && this._journey!.action === 'SELFIE') {
					crop.style.display = 'none';
				}
				const { type } = ImageService.getBase64Components(base64);
				if (image) {
					image.setAttribute('data-type', type);

					switch (type) {
						case ImageFormat.Pdf:
							if (this._journey!.action === 'SELFIE') {
								RenderingService.hideObject(upload);
							}
							image.setAttribute('src', 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMjMgMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnIGZpbGw9IiM5MjkyOTIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSJub25lIiA+PHBhdGggZD0iTTMsMGMtMS42NjEsMCwtMy4wMDcsMS4zNDIsLTMuMDA3LDIuOTk5bDAsNy4wMDJjMCwxLjY1NiwxLjMzNiwyLjk5OSwzLjAwNywyLjk5OWwxNi45ODYsMGMxLjY2MSwwLDMuMDA3LC0xLjM0MiwzLjAwNywtMi45OTlsMCwtNy4wMDJjMCwtMS42NTYsLTEuMzM2LC0yLjk5OSwtMy4wMDcsLTIuOTk5bC0xNi45ODYsMGwwLDB6bS0wLjAxMiwxYy0xLjEwMiwwLC0xLjk5NSwwLjksLTEuOTk1LDEuOTkybDAsNy4wMTZjMCwxLjEsMC45MDIsMS45OTIsMS45OTUsMS45OTJsMTcuMDExLDBjMS4xMDEsMCwxLjk5NCwtMC45LDEuOTk0LC0xLjk5MmwwLC03LjAxNmMwLC0xLjEsLTAuOTAyLC0xLjk5MiwtMS45OTQsLTEuOTkybC0xNy4wMTEsMGwwLDB6bTEzLjAwNSw1bDAsLTJsNCwwbDAsLTFsLTUsMGwwLDdsMSwwbDAsLTNsMywwbDAsLTFsLTMsMGwwLDB6bS0xMywtMWwwLDVsMSwwbDAsLTNsMS45OTUsMGMxLjEwNywwLDIuMDA1LC0wLjg4OCwyLjAwNSwtMmMwLC0xLjEwNSwtMC44OTQsLTIsLTIuMDA1LC0ybC0yLjk5NSwwbDAsMmwwLDB6bTEsLTFsMCwybDIuMDAxLDBjMC41NTIsMCwwLjk5OSwtMC40NDQsMC45OTksLTFjMCwtMC41NTIsLTAuNDQzLC0xLC0wLjk5OSwtMWwtMi4wMDEsMGwwLDB6bTUsLTFsMCw3bDIuOTk1LDBjMS4xMDcsMCwyLjAwNSwtMC44ODcsMi4wMDUsLTIuMDA2bDAsLTIuOTg4YzAsLTEuMTA4LC0wLjg5NCwtMi4wMDYsLTIuMDA1LC0yLjAwNmwtMi45OTUsMGwwLDB6bTEsMWwwLDVsMi4wMDEsMGMwLjU1MiwwLDAuOTk5LC0wLjQ0NCwwLjk5OSwtMWwwLC0zYzAsLTAuNTUyLC0wLjQ0MywtMSwtMC45OTksLTFsLTIuMDAxLDBsMCwweiIvPjwvZz48L3N2Zz4=');
							if (crop) {
								crop.style.display = 'none';
							}
							break;
						case ImageFormat.Bmp:
						case ImageFormat.Jpeg:
						case ImageFormat.Jpg:
						case ImageFormat.Png:
							image.setAttribute('src', base64);
							break;
						default:
							image.removeAttribute('src');
							break;
					}
				}

				if (openPreviewInfoId instanceof HTMLElement) {
					openPreviewInfoId.addEventListener('click', () => {
						RenderingService.showObject(previewInfoContainerId);
						RenderingService.showObject(closePreviewInfoId);
						RenderingService.hideObject(openPreviewInfoId);
					});
				}

				if (closePreviewInfoId instanceof HTMLElement) {
					closePreviewInfoId.addEventListener('click', () => {
						RenderingService.hideObject(previewInfoContainerId);
						RenderingService.hideObject(closePreviewInfoId);
						RenderingService.showObject(openPreviewInfoId);
					});
				}

				if (openPreviewInfoFM instanceof HTMLElement) {
					openPreviewInfoFM.addEventListener('click', () => {
						RenderingService.showObject(previewInfoContainerFM);
						RenderingService.showObject(closePreviewInfoFM);
						RenderingService.hideObject(openPreviewInfoFM);
					});
				}

				if (closePreviewInfoFM instanceof HTMLElement) {
					closePreviewInfoFM.addEventListener('click', () => {
						RenderingService.hideObject(previewInfoContainerFM);
						RenderingService.hideObject(closePreviewInfoFM);
						RenderingService.showObject(openPreviewInfoFM);
					});
				}

				if (openPreviewInfoPOA instanceof HTMLElement) {
					openPreviewInfoPOA.addEventListener('click', () => {
						RenderingService.showObject(previewInfoContainerPOA);
						RenderingService.showObject(closePreviewInfoPOA);
						RenderingService.hideObject(openPreviewInfoPOA);
					});
				}

				if (closePreviewInfoPOA instanceof HTMLElement) {
					closePreviewInfoPOA.addEventListener('click', () => {
						RenderingService.hideObject(previewInfoContainerPOA);
						RenderingService.hideObject(closePreviewInfoPOA);
						RenderingService.showObject(openPreviewInfoPOA);
					});
				}
				if (openPreviewInfoCovid instanceof HTMLElement) {
					openPreviewInfoCovid.addEventListener('click', () => {
						RenderingService.showObject(previewInfoContainerCovid);
						RenderingService.showObject(closePreviewInfoCovid);
						RenderingService.hideObject(openPreviewInfoCovid);
					});
				}

				if (closePreviewInfoCovid instanceof HTMLElement) {
					closePreviewInfoCovid.addEventListener('click', () => {
						RenderingService.hideObject(previewInfoContainerCovid);
						RenderingService.hideObject(closePreviewInfoCovid);
						RenderingService.showObject(openPreviewInfoCovid);
					});
				}

				if (retry instanceof HTMLElement) {
					retry.addEventListener('click', () => {
						RenderingService.setEnabled(crop as HTMLInputElement, false);
						RenderingService.setEnabled(retry as HTMLInputElement, false);
						RenderingService.setEnabled(upload as HTMLInputElement, false);
						this._retry = true;
						this.evaluate();
					});
				}

				if (crop instanceof HTMLElement) {
					crop.addEventListener('click', () => {
						RenderingService.setEnabled(crop as HTMLInputElement, false);
						RenderingService.setEnabled(retry as HTMLInputElement, false);
						RenderingService.setEnabled(upload as HTMLInputElement, false);

						RenderingService.showObject(status as HTMLElement);
						RenderingService.setText(statusMessage as HTMLElement, LanguageService.getTranslation(TranslationKey.VIEW_CROPPING));

						this._journey!.crop({
							data: ImageService.getBase64Components(base64).data,
							inputFormat: 0
						})
							.then((result) => {
								this._cropResponse = result;
								this.evaluate();
							})
							.catch((e) => {
								RenderingService.showObject(status as HTMLElement);
								RenderingService.setText(statusMessage as HTMLElement, LanguageService.getTranslation(TranslationKey.EXCEPTION_NETWORK));
							})
							.then(() => {
								RenderingService.setEnabled(crop as HTMLInputElement, true);
								RenderingService.setEnabled(retry as HTMLInputElement, true);
								RenderingService.setEnabled(upload as HTMLInputElement, true);
							});
					});
				}

				if (upload instanceof HTMLElement) {
					upload.addEventListener('click', async () => {

						if (this._journey !== undefined && this._journey.action === FlowState.PASSIVE_LIVENESS) {
							RenderingService.setEnabled(crop as HTMLInputElement, false);
							RenderingService.setEnabled(retry as HTMLInputElement, false);
							RenderingService.setEnabled(upload as HTMLInputElement, false);
							RenderingService.showObject(loadingAnimationContainer);
							const response = await HttpService.post(
								HttpService.endpoints.passiveLiveness,
								JSON.stringify({
									Base64Input: base64,
									JourneyId: this._journey!.id,
								}),
								undefined,
								'passiveLiveness'
							);

							return EventService.publish(JourneyEvent.PASSIVE_LIVENESS_FINISHED, response);
						}
						else if (this._journey !== undefined && this._journey.action === FlowState.COVIDPASS) {
							RenderingService.setEnabled(crop as HTMLInputElement, false);
							RenderingService.setEnabled(retry as HTMLInputElement, false);
							RenderingService.setEnabled(upload as HTMLInputElement, false);
							RenderingService.showObject(status as HTMLElement);
							RenderingService.showObject(loadingAnimationContainer);

							return this.assertImageExists(base64)
								.then(() => this.getJourney())
								.then((journey) => journey.continueCovid(
									base64,
									this._journey!.id)
									.then((res) => DataService.getDataStore<IIdScanData>(DataStoreType.ID_SCAN).update(ImageProvider.parseResponseCovidData(res)))
									.then(() => this.evaluate())
									.then(this.updateJourneyFields)).catch((ex) => {
										RenderingService.showObject(status as HTMLElement);
										RenderingService.setText(statusMessage as HTMLElement, LanguageService.getTranslation(TranslationKey.EXCEPTION_NETWORK));
									})
								.then(() => {
									RenderingService.setEnabled(crop as HTMLInputElement, true);
									RenderingService.setEnabled(retry as HTMLInputElement, true);
									RenderingService.setEnabled(upload as HTMLInputElement, true);
								});

						}
						else {
							if (metaData.length === 0) {
								const _metaData: IMetaData[] = [{
									name: 'Capture Type',
									value: 'File Upload',
									step: '',
									type: 'Simple'
								}];

								metaData.push(..._metaData);
							}

							RenderingService.setEnabled(crop as HTMLInputElement, false);
							RenderingService.setEnabled(retry as HTMLInputElement, false);
							RenderingService.setEnabled(upload as HTMLInputElement, false);

							RenderingService.showObject(status as HTMLElement);
							RenderingService.showObject(loadingAnimationContainer);
							return this.assertImageExists(base64)
								.then(() => this.getJourney())
								.then((journey) => journey.continue({
									imgList: [{
										...ImageService.remapNames(ImageService.getBase64Components(base64)),
										name: journey.action === 'SELFIE' ? RequiredInputImage.SelfiePhoto : RequiredInputImage.WhiteImage,
										inputFormat: type === 'pdf' ? 1 : 0
									}],
									journeyDefinitionId: this._journeyDefinitionId
								}, metaData)
									.then((res) => DataService.getDataStore<IIdScanData>(DataStoreType.ID_SCAN).update(ImageProvider.parseResponseData(res)))
									.then(() => this.evaluate())
									.then(this.updateJourneyFields))
								.catch((e) => {
									RenderingService.showObject(status as HTMLElement);
									RenderingService.setText(statusMessage as HTMLElement, LanguageService.getTranslation(TranslationKey.EXCEPTION_NETWORK));
								})
								.then(() => {
									RenderingService.setEnabled(crop as HTMLInputElement, true);
									RenderingService.setEnabled(retry as HTMLInputElement, true);
									RenderingService.setEnabled(upload as HTMLInputElement, true);
								});
						}
					});
				}
			})
			.then(() => EventService.publish(JourneyEvent.DISPLAY_PROVIDER, { provider: Templates.View }));
	}

	public static parseResponseData = ({
		entryData,
		entryDateTime,
		journeyId,
		requiredAction,
		highLevelResult,
		currentResult,
		hasError,
		isFinished
	}: UploadResponse): Partial<IIdScanData> => ({
		journeyId,
		journeyReference: entryData.scanReference,
		blurCheck: entryData.glareCheck,
		glareCheck: entryData.blurCheck,
		lowResolutionCheck: entryData.lowResolutionCheck,
		fullDocumentInViewCheck: entryData.fullDocumentInViewCheck,
		tripleScanReason: entryData.tripleScanReason,
		documents: (entryData.documents || []).map((doc): IExtendedDocument => removeNullOrUndefined({
			expirationDate: doc.expirationDate,
			issueDate: doc.issueDate,
			issueNumber: doc.issueNumber,
			number: doc.number,
			type: doc.type,
			blurCheck: entryData.blurCheck === 'Good',
			glareCheck: entryData.glareCheck === 'Good',
			lowResolutionCheck: entryData.lowResolutionCheck === 'Good',
			fullDocumentInViewCheck: entryData.fullDocumentInViewCheck === 'Good',
			scanReference: entryData.scanReference,
			tripleScanReason: entryData.tripleScanReason,
			scannerIp: entryData.scannerIp,
			dateTime: entryDateTime ? new Date(entryDateTime) : undefined
		})),
		person: removeNullOrUndefined({
			address: {
				city: entryData.holder.address.city,
				full: entryData.holder.address.full,
				postCode: entryData.holder.address.postCode,
			},
			birthDate: entryData.holder.birthDate,
			birthPlace: entryData.holder.birthPlace,
			firstName: entryData.holder.firstName,
			fullName: entryData.holder.fullName,
			middleName: entryData.holder.middleName,
			lastName: entryData.holder.lastName,
			gender: entryData.holder.gender,
		}) as IPerson,
		requiredAction,
		highLevelResult,
		currentResult,
		hasError,
		isFinished
	})

	public static parseResponseCovidData = ({
		entryData,
		entryDateTime,
		journeyId,
		requiredAction,
		highLevelResult,
		currentResult,
		hasError,
		isFinished
	}: UploadResponse): Partial<IIdScanData> => ({
		journeyId,
		journeyReference: entryData.scanReference,
		blurCheck: entryData.glareCheck,
		glareCheck: entryData.blurCheck,
		lowResolutionCheck: entryData.lowResolutionCheck,
		fullDocumentInViewCheck: entryData.fullDocumentInViewCheck,
		tripleScanReason: entryData.tripleScanReason,
		documents: (entryData.documents || []).map((doc): IExtendedDocument => removeNullOrUndefined({
			expirationDate: doc.expirationDate,
			issueDate: doc.issueDate,
			issueNumber: doc.issueNumber,
			number: doc.number,
			type: doc.type,
			blurCheck: entryData.blurCheck === 'Good',
			glareCheck: entryData.glareCheck === 'Good',
			lowResolutionCheck: entryData.lowResolutionCheck === 'Good',
			fullDocumentInViewCheck: entryData.fullDocumentInViewCheck === 'Good',
			scanReference: entryData.scanReference,
			tripleScanReason: entryData.tripleScanReason,
			scannerIp: entryData.scannerIp,
			dateTime: entryDateTime ? new Date(entryDateTime) : undefined
		})),
		requiredAction,
		highLevelResult,
		currentResult,
		hasError,
		isFinished
	})

	private static loadingAnimation: lottie.AnimationItem | undefined;

}
